<template>
    <div>
        <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
        :height="150"
        :width="150"
        :color="'#FFFF00'"
        :background-color="'#000000'"
        :opacity="0.5"
        ></loading>
        <div v-if="!loading">

            <!-- Back button: sits at the top of the outer card, never scrolls -->
            <div class="la-back-bar">
                <v-btn color="warning" style="width:100px;" @click="goBack()">
                    {{$t('button.back')}}
                </v-btn>
            </div>

            <!-- Scrollable content -->
            <div class="la-scroll-content">
                <app-leave-details
                    v-bind:leaveDetail="this.leaveDetail"
                    v-bind:staffApproveList="this.staffApproveList"
                />
            </div>

        </div>
    </div>
</template>

<script>

import LeaveDetails from '../../sscomponents/leaveapproval/LeaveDetails.vue'
import moment from 'moment'
import Loading from "vue-loading-overlay";

export default {

    components: {
        "app-leave-details": LeaveDetails,
        Loading
    },

    data() {
        return {

            leaveDetail: null,
            wftList: [],
            leavePartialRecord: [],
            leaveApprInfo: [],
            inactiveworkflow: Boolean,
            staffApproveList: [],

            loading: true

        }
    },

    methods: {
        goBack() {
            this.$router.push({name: 'selfservicemytask'});
        },

        // loadWorkflowTransactionDetails() {
        //     const vm = this;
        //     vm.loading = true;
            
        //     this.$store.dispatch('get', {url: "/workflowtransaction/approvalinfo/" + this.leaveDetail.wftranid})
        //     .then((res) => {
        //         const result = res.data;
        //         if (result.status === 200) {
        //             let wftholder = result.rec
        //             if(wftholder.length > 0) {
        //                 for (let i = 0; i < wftholder.length; i++) {
        //                     if (wftholder[i].remark == 'null') wftholder[i].remark = null
        //                     wftholder[i].aprv = moment(wftholder[i].aprdate).format('DD-MM-YYYY HH:mm:ss')
        //                     this.wftList.push(wftholder[i])
        //                 }
        //             }
        //         }

        //         vm.loading = false;

        //     }).catch((err) => {
        //         vm.loading = false;
        //         console.error(err)
        //     });
        // },

        async loadWorkflowTransactionDetails() {
            try {
                const res = await this.$store.dispatch('get', {
                    url: "/workflowtransaction/approvalinfo/" + this.leaveDetail.wftranid
                });

                const result = res.data;

                if (result.status === 200) {
                    const wftholder = result.rec;

                    if (wftholder && wftholder.length > 0) {
                        for (let i = 0; i < wftholder.length; i++) {

                            if (wftholder[i].remark === 'null') {
                                wftholder[i].remark = null;
                            }

                            wftholder[i].aprv = moment(wftholder[i].aprdate)
                                .format('DD-MM-YYYY HH:mm:ss');

                            this.wftList.push(wftholder[i]);
                        }
                    }
                }

            } catch (err) {
                console.error(err);
            }
        },

        // loadLeavePartial() {
        //     const vm = this;
        //     vm.loading = true;
        //     this.$store.dispatch('get', {url: "/leaverecordpartial/" + this.leaveDetail.recordid})
        //     .then((res) => {
        //         const result = res.data;
        //         if (result.status === 200) {
        //             this.leavePartialRecord = result.rec
        //             if(this.leavePartialRecord.length > 0){
        //                 for (let i = 0; i < this.leavePartialRecord.length; i++) {
        //                     this.leavePartialRecord[i].datedisplay = moment(this.leavePartialRecord[i].startdatetime).format('DD-MM-YYYY')
        //                     this.leavePartialRecord[i].starttimedisplay = moment(this.leavePartialRecord[i].startdatetime).format('hh:mm A')
        //                     this.leavePartialRecord[i].endtimedisplay = moment(this.leavePartialRecord[i].enddatetime).format('hh:mm A')
        //                 }
        //             }
        //         }

        //         vm.loading = false;

        //     }).catch((err) => {
        //         vm.loading = false;
        //         console.error(err)
        //     });
        // },

        async loadLeavePartial() {
            try {
                const res = await this.$store.dispatch('get', {
                    url: "/leaverecordpartial/" + this.leaveDetail.recordid
                });

                const result = res.data;

                if (result.status === 200) {
                    this.leavePartialRecord = result.rec;

                    if (this.leavePartialRecord && this.leavePartialRecord.length > 0) {
                        for (let i = 0; i < this.leavePartialRecord.length; i++) {

                            const record = this.leavePartialRecord[i];

                            record.datedisplay = moment(record.startdatetime)
                                .format('DD-MM-YYYY');

                            record.starttimedisplay = moment(record.startdatetime)
                                .format('hh:mm A');

                            record.endtimedisplay = moment(record.enddatetime)
                                .format('hh:mm A');
                        }
                    }
                }

            } catch (err) {
                console.error(err);
            }
        },

        // loadWorkflowTransactionApproval() {

        //     const vm = this;
        //     vm.loading = true;

        //     this.$store.dispatch('get', {url: "/leaverecord/wftran/" + this.leaveDetail.recordid})
        //     .then((res) => {

        //         const result = res.data;

        //         if (result.status === 200) {

        //             vm.leaveApprInfo = result.rec

        //             if (vm.leaveApprInfo.length > 0) {

        //                 for (var i = 0; i < vm.leaveApprInfo.length; i++) {

        //                     if (vm.leaveApprInfo[i].aprdate) {
        //                         vm.leaveApprInfo[i].aprdate = moment(vm.leaveApprInfo[i].aprdate).format("YYYY-MM-DD HH:mm:ss");
        //                     }

        //                     if (vm.leaveApprInfo[i].wfstatus == 'PENDING') {
        //                         vm.inactiveworkflow = !vm.inactiveworkflow
        //                     }
        //                 }

        //             }

        //         }

        //         vm.staffApproveList = vm.leaveApprInfo.filter(val => val.wfstatus == 'DONE')

        //         vm.loading = false;

        //     }).catch((err) => {
        //         vm.loading = false;
        //         console.error(err)
        //     });

        // }

        async loadWorkflowTransactionApproval() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/leaverecord/wftran/" + this.leaveDetail.recordid
                });

                const result = res.data;

                if (result.status === 200) {

                    vm.leaveApprInfo = result.rec;

                    if (vm.leaveApprInfo && vm.leaveApprInfo.length > 0) {

                        for (let i = 0; i < vm.leaveApprInfo.length; i++) {

                            const item = vm.leaveApprInfo[i];

                            if (item.aprdate) {
                                item.aprdate = moment(item.aprdate)
                                    .format("YYYY-MM-DD HH:mm:ss");
                            }

                            if (item.wfstatus === 'PENDING') {
                                vm.inactiveworkflow = !vm.inactiveworkflow;
                            }
                        }
                    }
                }

                vm.staffApproveList = vm.leaveApprInfo
                    ? vm.leaveApprInfo.filter(val => val.wfstatus === 'DONE')
                    : [];

            } catch (err) {
                console.error(err);
            }
        },
    },

    async mounted() {
        this.loading = true;
        this.leaveDetail = this.$route.params.item;
        this.leaveDetail.startdate = moment(this.leaveDetail.startdate).format('YYYY-MM-DD')
        this.leaveDetail.enddate = moment(this.leaveDetail.enddate).format('YYYY-MM-DD')


        await this.loadWorkflowTransactionDetails();
        await this.loadLeavePartial();
        await this.loadWorkflowTransactionApproval();

        this.loading = false;
    }

}

</script>

<style scoped>
.la-back-bar {
    padding: 14px 16px 10px 16px;
    border-bottom: 1px solid #F1F5F9;
}
.la-scroll-content {
    height: calc(100vh - 175px);
    overflow-y: auto;
    padding: 16px;
}
.la-scroll-content::-webkit-scrollbar { width: 6px; }
.la-scroll-content::-webkit-scrollbar-track { background: #F8FAFF; }
.la-scroll-content::-webkit-scrollbar-thumb { background: #C7D2FE; border-radius: 3px; }
</style>